export const COOKIE_CONSENT_NEEDED = 'needed';
export const COOKIE_CONSENT_ALL = 'all';
export const COOKIE_CONSENT_NO = 'no';
